var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col"},[_c('label',{staticClass:"inline-flex items-center",class:[
      { 'flex-row-reverse': _vm.align === 'left'}
    ]},[(_vm.value instanceof Array)?_c('span',{staticClass:"flex-grow inline-block",class:[
        { 'ml-4': _vm.align === 'left'},
        { 'mr-4 text-right': _vm.align === 'right'}
      ]},[_vm._t("input",function(){return [_vm._v("Need Input")]})],2):_c('span',{staticClass:"flex-grow",class:[
        { 'ml-4': _vm.align === 'left'},
        { 'mr-4 text-right': _vm.align === 'right'}
      ]},[_vm._v(_vm._s(_vm.label || _vm.displayValue))]),_c('input',{staticClass:"form-checkbox w-6 h-6 border-gray-600",class:[
        { 'bg-gray-200': _vm.disabled} ],attrs:{"type":"checkbox","disabled":_vm.disabled,"data-test":("option-" + _vm.slugValue)},domProps:{"checked":_vm.checked,"value":_vm.displayValue},on:{"change":_vm.updateInput}})]),_vm._t("default",null,{"checked":_vm.checked})],2)}
var staticRenderFns = []

export { render, staticRenderFns }